// src/components/Services.js
import React from 'react';
import { Container, Typography } from '@mui/material';

const Services = () => {
  return (
    <Container>
      <Typography variant="h4" sx={{ mt: 4 }}>Our Courses</Typography>
      <Typography sx={{ mt: 2 }}>
      At Aniketan/Kadabi Primary/Higher English Medium School-Pattihal,K.B , we offer specialized courses like full time course,summer vacation with regular classes
      </Typography>
    </Container>
  );
};

export default Services;
